import styled from "styled-components";

export const ProductArea = styled.div`
  display: grid;
  margin: 40px 0;
  margin-right: 20%;
  margin-left: 20%;
  @media (max-width: 900px) {
    margin-right: 5%;
    margin-left: 5%;
  }


  @media (max-width: 819px) {
    display: block;
  } 
  body {
    background: #999;
    margin: 0;
    padding: 0;
  }
  
   .wrapper {
      position: relative;
      width: 250px;
      height: auto;
      right: 60px;
    }
  
    @media screen and (max-width: 600px) {
    .wrapper {
      position: relative;
      width: 0px;
      height: 0px;
    }  
    }

  @media screen and (max-width: 600px) {
    #container {
      visibility: hidden;
      width: 230px;
      height: 380px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }
  } 
  @media screen and (max-width: 600px) {
    #container-noImage {
      visibility: hidden;
      width: 230px;
      height: 150px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }
  } 
    #container-noImage {
      // visibility: hidden;
      width: 230px;
      height: 150px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }
    #container {
      // visibility: hidden;
      width: 230px;
      height: auto;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }

  @media screen and (max-width: 600px) {
    #container-origin {
      visibility: hidden;
      width: 230px;
      height: 150px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }
  } 
    #container-origin {
      // visibility: hidden;
      width: 230px;
      height: 150px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }

  @media screen and (max-width: 600px) {
    #container-outlet {
      visibility: hidden;
      width: 230px;
      height: 150px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }
  }
    #container-outlet {
      // visibility: hidden;
      width: 230px;
      height: 150px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }

    #container-release {
      // visibility: hidden;
      width: 230px;
      height: 120px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }
  @media screen and (max-width: 600px) {
    #container-release {
      visibility: hidden;
      width: 230px;
      height: 120px;
      padding: 5px;
      margin-top: 0px;
      position: relative;
      right: 10px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      background: #FFF;
      border: 1px #D3D3D3 solid;
      margin: 20px auto;
      padding: 15px;
    }
  }

  .ssb_down {
    background-color: #33ccaa;
    bottom:0;
    cursor:pointer;
    position:absolute;
    right:0;
    border-radius: 10px;
  }
  
  .ssb_sb {
    background-color: #22aabb;
    cursor:pointer;
    position:absolute;
    right:0;
    border-radius: 10px;
  }
  
  .ssb_sb_down {
    background-color: #1199aa;
  }
  
  .ssb_sb_over {
    background-color: #33bbcc;
  }
  
  .ssb_st {
    background-color: #dedede;
    cursor:pointer;
    height:100%;
    position:absolute;
    right:0;
    top:0;
    border-radius: 10px;
  }
  
  .ssb_up {
    background-color: #33ccaa;
    cursor:pointer;
    position:absolute;
    right:0;
    top:0;
    border-radius: 10px;
  }
  
  .parent {
    height:50px;
    padding:10px;
    position: absolute
    top: 0;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 5px;
  }
  }
  
  
`;

export const CategoryList = styled.aside`
  @media (max-width: 819px) {
    display: none;
  }

  h2 {
    color: #222;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 30px;
  }
`;
